import * as yup from "yup";

import { type Shape } from "@ds/utils/validation";

const nameSchema = yup
  .string()
  .required("Please specify campaign name")
  .max(256, "Name must not exceed 256 characters");

const mixingStrategySchema = yup
  .string()
  .required("Please select a mixing strategy")
  .oneOf(["time_slice", "interleaved"] as const, "Invalid mixing strategy");

export const createValidationSchema = {
  step1: yup.object().shape<Shape<Campaign>>({
    name: nameSchema,
    mixing_strategy: mixingStrategySchema,
  }),
};

export const updateValidationSchema = {
  info: yup.object().shape<Shape<Campaign>>({
    name: nameSchema,
    mixing_strategy: mixingStrategySchema,
  }),
};
